import { videoModel } from 'common/api/models/video';

/**
 * @param raw
 * @return {{uploadUrl: *, video: {id: string, title: string, description: string, thumbnail: string, length: number, displayDate: number, modifiedDate: number, uploadDate: number, generation: number, plays: number, views: number, allFormatsAvailable: boolean, customMetadata: Array, keywords: Array, stills: Array, published: boolean, channels: {id: number, name: string}[], playerToken: string}}}
 */
export const uploadVideoModel = (raw) => {
  return {
    uploadUrl: raw.uploadUrl,
    video: videoModel(raw.video),
  };
};
